/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/destructuring-assignment */
import { Group, Space } from '@mantine/core';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import PageSection from '../../../../../../components/core/PageSection/PageSection';
import ProfileCardLink from '../../../../../../components/core/ProfileCardLink/ProfileCardLink';
import TableCellEllipsis from '../../../../../../components/core/TableCellEllipsis/TableCellEllipsis';
import { EntityDestinationType } from '../../../../../../models/core/entities.type';
import { Feature } from '../../../../../../utils/constants.utils';
import { formatTimestampToString } from '../../../../../../utils/formatter.utils';

type ViewProps = {
  data: EntityDestinationType[];
};

export default function DestinationView(props: ViewProps) {
  const columns: ColumnsType<any> = [
    {
      title: 'Destino Final',
      key: 'residuoDestinoFinal',
      dataIndex: 'residuoDestinoFinal',
      sorter: (a: EntityDestinationType, b: EntityDestinationType) =>
        a.residuoDestinoFinal.localeCompare(b.residuoDestinoFinal),
    },
    {
      title: 'Descrição',
      key: 'residuoDestinoFinalDescricao',
      sorter: (a: EntityDestinationType, b: EntityDestinationType) =>
        (a.residuoDestinoFinalDescricao || '').localeCompare(b.residuoDestinoFinalDescricao || ''),
      render: (row: EntityDestinationType) => (
        <TableCellEllipsis label={row?.residuoDestinoFinalDescricao} numberOfChars={25} toolTipWidth={300} />
      ),
    },
    {
      title: 'Criado Por',
      key: 'criadoPor',
      sorter: (a: EntityDestinationType, b: EntityDestinationType) => a.criadoPor.localeCompare(b.criadoPor),
      render: (row: EntityDestinationType) => (
        <ProfileCardLink id={row.idCriadoPor} name={row.criadoPor} nameSize="sm" />
      ),
    },
    {
      title: 'Data Criação',
      key: 'dataCriacao',
      sorter: (a: EntityDestinationType, b: EntityDestinationType) => {
        const aValue = a.dataCriacao.valueOf();
        const bValue = b.dataCriacao.valueOf();
        if (aValue === bValue) {
          return 0;
        }
        return aValue > bValue ? 1 : -1;
      },
      render: (row: EntityDestinationType) => formatTimestampToString(row.dataCriacao),
    },
  ];

  return (
    <div>
      <Group>
        <PageSection size="lg" color={Feature.Reference.Entity.color} label="Destinos Finais" text="" />
      </Group>
      <Space h="xs" />
      <Table
        showSorterTooltip={false}
        // size="small"
        dataSource={props.data}
        columns={columns}
        rowKey={(item: EntityDestinationType) => item.idEntidadeResiduoDestinoFinal || 0}
        pagination={{
          pageSizeOptions: [10, 25, 50],
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
        }}
      />
    </div>
  );
}
